import { Form } from "antd";
import { useContext, useEffect, useState } from "react";
import CustomDropdown from "../../../component/CustomDropdown";
import CustomSingleDropdown from "../../../component/CustomeSigleDropDown";
import FilledButton from "../../../component/FilledButton";
import FormInput from "../../../component/FormInput";
import { ContextState } from "../../../layout";

const AddUser = ({ btnLoader, userId, attachCourse, errorData, handleError, handleAddUser, category, handleChange, formData, handleModalClose, setFormRef, startDateDataFromCourse, handleStartDateChange }) => {
    const [form] = Form.useForm();
    const [program, setProgram] = useState()
    form.setFieldsValue(formData);
    const { contextReducer } = useContext(ContextState);

    useEffect(()=>{
        const programs = [];
        category?.forEach(item => {
            const newObj = {
                id: item?.programID,
                name: item?.outline[0]?.program_name
            };
            programs.push(newObj);
            setProgram(programs)
        });
        },[category])

    useEffect(() => {
        setFormRef(form);
    }, []);

    return (
        <div className="modal_body">
            <div className="add_thought_leader">
                <Form
                    form={form}
                    name="register"
                    onFinish={(e) => handleAddUser(e, form)}
                    onReset={handleModalClose}
                    scrollToFirstError
                    className="attached_courses-add_skill"
                >
                    <h2>{attachCourse ? 'link course' : userId ? 'Edit User' : 'add user'}</h2>
                    <Form.Item name="email">
                        <FormInput
                            label="Email *"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            error={errorData['email']}
                            onFocus={(e) => handleError(e)}
                            disabled={attachCourse || userId ? true : false}
                        />
                    </Form.Item>

                    {(!attachCourse || userId) && <>
                        <Form.Item name="first_name">
                            <FormInput
                                label={contextReducer.cms_type === 'dl-program' ? "First Name *" : "First Name" } 
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                error={errorData['first_name']}
                                onFocus={(e) => handleError(e)}
                            />
                        </Form.Item>

                        <Form.Item name="last_name">
                            <FormInput
                                label={contextReducer.cms_type === 'dl-program' ? "Last Name *" : "Last Name" } 
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                error={errorData['last_name']}
                                onFocus={(e) => handleError(e)}
                            />
                        </Form.Item>
                    </>}

                    {(contextReducer.cms_type === 'pre-college' || contextReducer.cms_type === 'certificates') && !userId &&
                        // <CustomDropdown
                        //     options={category}
                        //     name="course_name"
                        //     forlabel='Course(s) *'
                        //     value={formData.course_name}
                        //     onChange={handleChange}
                        //     error={errorData['course_name']}
                        //     onFocus={() => handleError({ target: { name: "course_name" } })}
                        //     showSearch
                        // />
                        <>
                            <CustomSingleDropdown
                                options={category}
                                name="course_name"
                                forlabel='Course(s) *'
                                value={formData.course_name}
                                onChange={handleChange}
                                error={errorData['course_name']}
                                onFocus={() => handleError({ target: { name: "course_name" } })}
                                showSearch
                            />
                            {contextReducer.cms_type === 'certificates' &&  startDateDataFromCourse?.length === 0 ? 
                                  "":
                                <CustomSingleDropdown
                                options={startDateDataFromCourse}
                                name="course_start_date"
                                forlabel='Course start date'
                                value={formData?.course_start_date}
                                onChange={handleStartDateChange}
                                // error={errorData['course_start_date']}
                                // onFocus={() => handleError({ target: { name: "course_start_date" } })}
                                showSearch
                            />
                            }
                            
                        </>

                    }
                    {contextReducer.cms_type === 'dl-program' && !userId &&  
                    <>
                        <CustomSingleDropdown
                            options={program}
                            name="program_name"
                            forlabel='Program name *'
                            value={formData.program_name}
                            onChange={handleChange}
                            error={errorData['program_name']}
                            onFocus={() => handleError({ target: { name: "program_name" } })}
                            showSearch
                        />
                         {/* <CustomSingleDropdown
                            options={startDateDataFromCourse}
                            name="program_start_date"
                            forlabel='Program Start Date '
                            value={formData?.course_start_date}
                            onChange={handleStartDateChange}
                            error={errorData['program_start_date']}
                            onFocus={() => handleError({ target: { name: "program_start_date" } })}
                            showSearch
                        /> */}
                </>
                    }
                    <div class="form_group form_footer d_flex_center">
                        <button type="reset" className="btn btn_gray">cancel</button>
                        <FilledButton type="submit" loading={btnLoader} value={userId ? "update" : "invite"} className="btn btn_primary" />
                    </div>
                </Form>
            </div>
        </div>
    )
};

export default AddUser;